<template lang="pug">

div.ui.error.form
    p.field.ui.error.message {{ validation.firstError('isBillingAddress') }}

    .ui.three.column.grid

        //- Lieferadresse
        .column

            //- Ist Lieferadresse
            slider-checkbox-field(
                v-model="isShippingAddress"
                label="Ist Lieferadresse"
                v-bind:disabled='lockIsShippingAddress'
            )

            //- Als Standard-Lieferadresse festlegen
            slider-checkbox-field(
                v-show="isShippingAddress"
                label="Als Standard-Lieferadresse festlegen"
                v-bind:disabled='lockIsDefaultShippingAddress'
                v-bind:value="isDefaultShippingAddress"
                v-on:input="updateDefaultShippingAddress"
            )

                //- Warnhinweis
                .ui.small.orange.message(v-if="!hideShippingAddressWarning" v-show="isDefaultShippingAddress")
                    strong Warnung!
                    |  Die bisherige Standard-Lieferadresse des Unternehmens wird überschrieben

        //- Rechnungsadresse
        .column

            //- Ist Rechnungsadresse
            slider-checkbox-field(
                label="Ist Rechnungsadresse"
                v-bind:disabled='lockIsBillingAddress'
                v-model='isBillingAddress'
            )

            //- Als Standard-Rechnungsadresse festlegen
            slider-checkbox-field(
                v-show="isBillingAddress"
                label="Als Standard-Rechnungsadresse festlegen"
                v-bind:disabled='lockIsDefaultBillingAddress'
                v-bind:value='isDefaultBillingAddress'
                v-on:input='updateDefaultBillingAddress'
            )

                //- Warnhinweis
                .ui.small.orange.message(v-if='!hideBillingAddressWarning' v-show="isDefaultBillingAddress")
                    strong Warnung!
                    |  Die bisherige Standard-Rechnungsadresse des Unternehmens wird überschrieben

        //- Korrespondenzadresse
        .column

            //- Als Standard-Korrespondenzadresse festlegen
            slider-checkbox-field(
                label="Ist Korrespondenzadresse"
                v-model='isCorrespondenceAddress'
                v-bind:disabled='lockIsCorrespondenceAddress'
            )

            //- Als Standard-Korrespondenzadresse festlegen
            slider-checkbox-field(
                v-show="isCorrespondenceAddress"
                label="Als Standard-Korrespondenzadresse festlegen"
                v-bind:disabled='lockIsDefaultCorrespondenceAddress'
                v-bind:value='isDefaultCorrespondenceAddress'
                v-on:input='updateDefaultCorrespondenceAddress'
            )

                //- Warnhinweis
                .ui.small.orange.message(v-if='!hideCorrespondenceAddressWarning' v-show="isDefaultCorrespondenceAddress")
                    strong Warnung!
                    |  Die bisherige Standard-Korrespondenzadresse des Unternehmens wird überschrieben

</template>

<script>
    import * as R from 'ramda'
    import { Validator } from 'simple-vue-validator'
    import SliderCheckboxField from '@/components/form/SliderCheckboxField'

    //noinspection JSUnusedGlobalSymbols,ReservedWordAsName
    export default {

        name: 'address-type-form',

        components: { SliderCheckboxField },

        computed: {

            isBillingAddress: {
                get() { return this.value.isBillingAddress || false },
                set(value) { this.updateValue('isBillingAddress', value) }
            },

            isCorrespondenceAddress: {
                get() { return this.value.isCorrespondenceAddress || false },
                set(value) { this.updateValue('isCorrespondenceAddress', value) }
            },

            isShippingAddress: {
                get() { return this.value.isShippingAddress || false },
                set(value) { this.updateValue('isShippingAddress', value) }
            },

        },

        created() {
            // ggf. Vorauswahl fuer Typen setzen
            const model = {
                ...this.value,
                isBillingAddress:        R.defaultTo(false, this.value.isBillingAddress),
                isCorrespondenceAddress: R.defaultTo(false, this.value.isCorrespondenceAddress),
                isShippingAddress:       R.defaultTo(false, this.value.isShippingAddress),
            }

            this.$emit('input', model)
        },

        methods: {
            updateDefaultBillingAddress(value) {
                this.$emit('default-billing-address', value)
            },

            updateDefaultCorrespondenceAddress(value) {
                this.$emit('default-correspondence-address', value)
            },

            updateDefaultShippingAddress(value) {
                this.$emit('default-shipping-address', value)
            },

            updateValue(prop, value) {
                this.$emit('input', R.assoc(prop, value, this.value))
            },

            validate() {
                return this.$validate()
            }

        },

        props: {

            hideBillingAddressWarning: {
                type: Boolean,
                default: false
            },

            hideCorrespondenceAddressWarning: {
                type: Boolean,
                default: false
            },

            hideShippingAddressWarning: {
                type: Boolean,
                default: false
            },

            isDefaultBillingAddress: {
                type: Boolean,
                default: false
            },

            isDefaultShippingAddress: {
                type: Boolean,
                default: false
            },

            isDefaultCorrespondenceAddress: {
                type: Boolean,
                default: false
            },

            lockIsBillingAddress: {
                type: Boolean,
                default: false
            },

            lockIsCorrespondenceAddress: {
                type: Boolean,
                default: false
            },

            lockIsShippingAddress: {
                type: Boolean,
                default: false
            },

            lockIsDefaultBillingAddress: {
                type: Boolean,
                default: false
            },

            lockIsDefaultShippingAddress: {
                type: Boolean,
                default: false
            },

            lockIsDefaultCorrespondenceAddress: {
                type: Boolean,
                default: false
            },

            value: {
                type: Object,
                required: true,
            }

        },

        validators: {

            'isBillingAddress, isCorrespondenceAddress, isShippingAddress'(billing, correspondence, shipphing) {
                return Validator.custom(() => {
                    // Mindestens ein Typ muss ausgewaehlt sein
                    if (R.all(R.equals(false), [ billing, correspondence, shipphing ])) {
                        return 'Mindestens einen Adresstypen auswählen'
                    }
                })
            }

        },

    }

</script>
